<template>

  <v-sidebar v-model:visible="display" :header="$t('settings')" position="right" :showCloseIcon="true"
             style = "width: 21.5rem;"
           :baseZIndex="1000" class="layout-config p-sidebar-sm p-0">
    <div class="layout-config-panel flex flex-column">


      <hr class="mb-0 mt-0" />

      <div class="layout-config-options p-3">
        <h6>{{$t('Language')}}</h6>
        <div class="flex">
          <div class="flex flex-column">
            <div v-for="(val, iter) in locales" :key="val.name + iter" @click="changeLocale(val.code)" class="flex align-items-center" :class="{'mt-3': iter >= 1}">
              <RadioButton id="menuMode1" name="locale" :value="val.code" :modelValue="locale"></RadioButton>
              <label  for="menuMode1" class="ml-2">{{ val.name }}</label>
            </div>
          </div>
        </div>

        <h6>{{$t('Layout/Theme Scale')}}</h6>
        <div class="flex align-items-center">
          <Button icon="pi pi-minus" @click="decrementScale()" class="p-button-rounded p-button-text" :disabled="scale === scales[0]"></Button>
          <i class="pi pi-circle-on m-1 scale-icon" v-for="s of scales" :key="s" :class="{'scale-active': s === scale}"></i>
          <Button icon="pi pi-plus" @click="incrementScale()" class="p-button-rounded p-button-text" :disabled="scale === scales[scales.length - 1]"></Button>
        </div>

<!--        <h6>Layout Mode</h6>-->
<!--        <div class="flex">-->
<!--          <div class="flex align-items-center">-->
<!--            <RadioButton id="light" name="layoutMode" value="light" v-model="d_layoutMode" @change="changeLayoutMode($event, 'light')" />-->
<!--            <label for="layoutMode1" class="ml-2">Light</label>-->
<!--          </div>-->
<!--          <div class="flex align-items-center" class="ml-4">-->
<!--            <RadioButton id="dark" name="layoutMode" value="dark" v-model="d_layoutMode" @change="changeLayoutMode($event, 'dark')" />-->
<!--            <label for="layoutMode2" class="ml-2">Dark</label>-->
<!--          </div>-->
<!--        </div>-->

        <h6>{{$t('Password')}}</h6>
        <div class="flex">
          <div class="flex flex-column">
            <a style="color: var(--primary-color)" href="https://account.activedirectory.windowsazure.com/ChangePassword.aspx">
              {{$t('change_password')}} <i class="pi pi-arrow-right fs-xsmall"></i>
            </a>
          </div>
        </div>
<!--        <div class="mt-5">-->
<!--          <h5>{{$t('advises')}}</h5>-->

<!--          <hr class="mb-0 mt-5" />-->
<!--          <div style="height: 38rem !important;" class="relative align-items-stretch flex flex-column align-content-center justify-content-center">-->
<!--            <div class="flex align-self-center align-items-center justify-content-center mb-6">-->
<!--              <img  src="/layout/images/push.svg"  style="height: 10rem">-->
<!--            </div>-->
<!--            <div class="flex align-items-center justify-content-center text-center">-->
<!--            <span style="font-size: 1.2rem">-->
<!--              {{ $t('no_content') }}-->
<!--            </span>-->
<!--              <br/>-->
<!--            </div>-->
<!--          </div>-->
<!--          </div>-->
      </div>
    </div>
  </v-sidebar>
  <ConfirmDialog :breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}"></ConfirmDialog>
</template>

<script>
import i18n from '@/locales/i18n'
import store from "@/store";
// import {useRoute} from "vue-router";
import vSidebar from "@/primevue/sidebar/Sidebar.vue"
export default {
  name: "UserSettingsSidebar",
  data() {
    return {
      display: false,
      locale: i18n.vueI18n.global.locale.value,
      scale: parseInt(store.state.scale),
      d_layoutMode: this.layoutMode,
      scales: [12,13,14,15,16],
      locales : i18n.locales
    }
  },
  components:{
    vSidebar
  },
  computed:{
    currentLocale(){
      return i18n.vueI18n.global.locale.value
    }
  },
  watch: {
    display(to, from) {
      if (to !== from)
        this.locale = this.currentLocale
    },
  },
  mounted() {
    this.locale = this.currentLocale;
  },
  methods:{
    onLayoutModeChange(){
      // const layoutLink = document.getElementById('layout-css');
      // const layoutHref = 'layout/css/layout-' + menuColor + '.css';
      // this.replaceLink(layoutLink, layoutHref);
      //
      // const themeLink = document.getElementById('theme-css');
      // const urlTokens = themeLink.getAttribute('href').split('/');
      // urlTokens[urlTokens.length - 1] = 'theme-' + menuColor + '.css';
      // const newURL = urlTokens.join('/');
      //
      // this.replaceLink(themeLink, newURL, () => {
      //   this.$appState.isNewThemeLoaded = true;
      // });

    },
    changeLocale(value) {
      console.log(value)
      this.$confirm.require({
        message: this.$t('warning_locale'),
        header: this.$t('confirmation'),
        rejectLabel: this.$t('cancel'),
        acceptLabel: this.$t('continue'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.$router.push({...this.$route, params: {...this.$route.params, locale: value}});
        }
      });
    },
    decrementScale() {
      if (this.scales.includes(this.scale)) {
        this.scale--;
        this.applyScale();
        this.$toast.add({severity: 'success', summary: 'Font', detail: 'Font diminished', life: 3000});
      }
    },
    incrementScale() {
      if (this.scales.includes(this.scale)){
        this.scale++;
        this.applyScale();
        this.$toast.add({ severity: 'success', summary: 'Font', detail: 'Font increased', life: 3000});
      }
    },
    applyScale() {
      document.documentElement.style.fontSize = this.scale + 'px';
      store.commit('setScale', this.scale)
    },
    openModal(){
      this.display = true
    }
  }
}
</script>

<style scoped>
.element {
  position: relative;
  left: 50%;
  top: 30%;
  transform: translateX(-50%);
}
</style>
